import React from "react";
import { GuestTopBar } from "../../components/GuestTopBar";

/**
 * Shared chrome + prose styling for the static legal pages (privacy, terms,
 * community guidelines). These are always public — reuses the same guest
 * top bar as the peak/landmark/explorer-profile pages (PLT-2), so signed-out
 * visitors get consistent nav even when they land here from a footer link.
 */
export function LegalLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: React.ReactNode;
}) {
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg-app)", display: "flex", flexDirection: "column" }}>
      <GuestTopBar />
      <div style={{ flex: 1, overflow: "auto", padding: "48px 24px 96px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <p className="eyebrow" style={{ marginBottom: 10 }}>Last updated {updated}</p>
          <h1 style={{ font: "var(--type-display)", fontSize: 40, color: "var(--text-primary)", margin: "0 0 28px" }}>
            {title}
          </h1>
          <div className="lp-legal-prose">{children}</div>
        </div>
      </div>
    </div>
  );
}

/**
 * Section heading + body helper — keeps the prose consistent without
 * re-typing inline styles on every page.
 */
export function LegalSection({ heading, children }: { heading: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ font: "var(--type-h3)", color: "var(--text-primary)", margin: "0 0 12px" }}>{heading}</h2>
      <div style={{ color: "var(--text-secondary)", fontSize: "var(--text-base)", lineHeight: "var(--leading-relaxed)", display: "flex", flexDirection: "column", gap: 12 }}>
        {children}
      </div>
    </section>
  );
}
